class GiftProducts extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-gift-view-all]');
    this.onClick = (event) => {
      if (!event.target.closest('[data-gift-view-all]')) return;
      this.querySelectorAll('[data-gift-extra]').forEach((card) => { card.hidden = false; });
      this.classList.add('is-expanded');
      this.button?.setAttribute('aria-expanded', 'true');
      const viewAll = this.button?.closest('.gift-products__view');
      if (viewAll) viewAll.hidden = true;
    };
    this.onSubmit = (event) => {
      const form = event.target.closest('[data-gift-product-form]');
      if (!form) return;
      event.preventDefault();
      this.addToCart(form, event.submitter);
    };
    this.addEventListener('click', this.onClick);
    this.addEventListener('submit', this.onSubmit);
  }
  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    this.removeEventListener('submit', this.onSubmit);
  }

  async addToCart(form, submitter) {
    if (form.dataset.submitting === 'true') return;

    const status = form.querySelector('[data-gift-cart-status]');
    const formData = new FormData(form);
    const quantity = Number(formData.get('quantity')) || 1;
    const sectionIds = [...document.querySelectorAll('cart-items-component[data-section-id]')]
      .map((component) => component.dataset.sectionId)
      .filter(Boolean);

    if (sectionIds.length) {
      formData.set('sections', [...new Set(sectionIds)].join(','));
      formData.set('sections_url', window.location.pathname);
    }

    form.dataset.submitting = 'true';
    if (submitter) {
      submitter.disabled = true;
      submitter.setAttribute('aria-busy', 'true');
    }
    if (status) status.textContent = '';

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      });
      const result = await response.json();

      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || 'Unable to add this item to the cart.');
      }

      form.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: result,
          sourceId: `gift-product-${form.dataset.productId || formData.get('id')}`,
          data: {
            source: 'product-form-component',
            itemCount: quantity,
            productId: form.dataset.productId,
            variantId: String(formData.get('id')),
            sections: result.sections || {},
          },
        },
      }));

      if (status) status.textContent = 'Added to cart.';
      const drawer = document.querySelector('cart-drawer-component');
      if (drawer) {
        await customElements.whenDefined('cart-drawer-component');
        const dialog = drawer.querySelector('dialog');
        if (!dialog?.open && typeof drawer.open === 'function') drawer.open();
      }
    } catch (error) {
      console.error(error);
      if (status) status.textContent = error.message;
    } finally {
      delete form.dataset.submitting;
      if (submitter) {
        submitter.disabled = false;
        submitter.removeAttribute('aria-busy');
      }
    }
  }
}

class GiftTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = [...this.querySelectorAll('[role="tab"]')];
    this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
    this.onClick = (event) => {
      const tab = event.target.closest('[role="tab"]');
      if (tab) this.activate(tab);
    };
    this.onKeydown = (event) => {
      const current = this.tabs.indexOf(event.target);
      if (current < 0 || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      let next = event.key === 'Home' ? 0 : event.key === 'End' ? this.tabs.length - 1 : current + (event.key === 'ArrowRight' ? 1 : -1);
      next = (next + this.tabs.length) % this.tabs.length;
      this.tabs[next].focus();
      this.activate(this.tabs[next]);
    };
    this.addEventListener('click', this.onClick);
    this.addEventListener('keydown', this.onKeydown);
  }
  activate(activeTab) {
    this.tabs.forEach((tab) => {
      const active = tab === activeTab;
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
    });
    this.panels.forEach((panel) => { panel.hidden = panel.id !== activeTab.getAttribute('aria-controls'); });
  }
  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    this.removeEventListener('keydown', this.onKeydown);
  }
}

if (!customElements.get('gift-products')) customElements.define('gift-products', GiftProducts);
if (!customElements.get('gift-tabs')) customElements.define('gift-tabs', GiftTabs);
